module.exports = __webpack_public_path__ + "static/media/016.bf5c2285.jpg";